import { InputField } from "components/InputField/Input";
import { CommonButton } from "components/Buttons/Buttons";
import { BiMinus, BiPlus } from "react-icons/bi";
import useItemDropdown from "./useItemDropdown";
import { dropdownFunction } from "utilities/dropdownFunction";

const useProductDataTable = (updateData, formik, setDeleteProductID, setShowDeleteProductModal) => {
    const addProductOnChange = (e, i, fieldName) => {
        formik.setFieldValue(`return_items[${i}].${fieldName}`, e?.value || e?.target?.value);
    };

    const { productDropdown, setProductDropdown, brandDropdown, setBrandDropdown, stockList, brandList} = useItemDropdown();

    const modalTableColumns = [
        {
            field: "stock",
            header: "Stock",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField
                        id="stock"
                        name="stock"
                        autoFilteredValue={productDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setProductDropdown, stockList)}
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "stock")}
                        value={formik.values.return_items[event.rowIndex]?.stock}
                        type="select"
                        label="Select Stock"
                        width="full"
                        autoCompleteFieldName="name"
                        disabled = {updateData ? true : false}
                        required={true}
                        errors={formik.errors.return_items?.[event.rowIndex]?.stock?.id}
                    />
                </div>
            ),
        },
        {
            field: "brand",
            header: "Brand",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField
                        id="brand"
                        name="brand"
                        autoFilteredValue={brandDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setBrandDropdown, brandList)}
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "brand")}
                        value={formik.values.return_items[event.rowIndex]?.brand}
                        type="select"
                        label="Select Brand"
                        width="full"
                        autoCompleteFieldName="name"
                        required={true}
                        errors={formik.errors.return_items?.[event.rowIndex]?.brand?.id}
                    />
                </div>
            ),
        },
        {
            field: "remain_quantity",
            header: "Remain Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="remain_quantity"
                        name="remain_quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "remain_quantity")}
                        value={formik.values.return_items[event.rowIndex]?.stock?.remain_quantity}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="remain_quantity"
                        required={true}
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.return_items?.[event.rowIndex]?.stock?.remain_quantity}
                    />
                </div>
            ),
        },
        {
            field: "return_quantity",
            header: "Return Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="return_quantity"
                        name="return_quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "return_quantity")}
                        value={formik.values.return_items[event.rowIndex]?.return_quantity}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="return_quantity"
                        required={true}
                        messagePosition='toast'
                        errors={formik.errors.return_items?.[event.rowIndex]?.return_quantity}
                    />
                </div>
            ),
        },
        {
            field: "reason",
            header: "Reason",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="reason"
                        name="reason"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "reason")}
                        value={formik.values.return_items[event.rowIndex]?.reason}
                        type="text"
                        width="full"
                        autoCompleteFieldName="reason"
                        required={false}
                        messagePosition='bottom'
                        errors={formik.errors.return_items?.[event.rowIndex]?.reason}
                    />
                </div>
            ),
        },
    ]

    const deleteRequisitionItems = (rowData) => {
        const {id, return_instance} = rowData;
        setDeleteProductID({id, return_instance})
        setShowDeleteProductModal(true)
    }

    const modalTableActionButton = (rowData, {rowIndex}) => {
        const handleOnFieldIncrement = () => {
            const joinData = formik.values.return_items.concat({
                fieldId: rowIndex + 1,
                stock: "",
                brand: "",
                stock_quantity: "",
                return_quantity: "",
                reason: "",
            });
            formik.setFieldValue("return_items", joinData)
        };

        const handleOnFieldDecrement = (i) => {
            if(rowData.id > 0){
                return deleteRequisitionItems(rowData)
            }
            const removeData = [...formik.values.return_items];
            removeData.splice(rowIndex, 1);
            formik.setFieldValue("return_items", removeData);
        };

        return (
            <>
                <div className="flex items-center justify-center">
                    {
                        formik.values.return_items.length - 1 === rowIndex ? (
                            <>
                                <CommonButton 
                                    icon={<BiPlus className="text-green-700 text-2xl" />}
                                    className="p-button-rounded p-mr-2 action-button-green"
                                    title=""
                                    type="button"
                                    onClick={handleOnFieldIncrement}
                                />
                                {formik.values.return_items.length !== 1 && 
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />}
                            </>
                        ) : 
                        (
                            <>
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />
                            </>
                        )
                    }
                </div>
            </>
        )
    }

    return {
        modalTableColumns,
        modalTableActionButton,
    }
}

export default useProductDataTable